<template>
  <div class="floating-button">
        <a
          class="a-tooltip-primary a-tooltip-left zen-desk"
          data-tooltip-text="Soporte"
          href="#"
          @click.prevent="openModal"
        >
          <img width="45" height="45" src="@/assets/img/play-ayuda.png">
        </a>
  </div>
</template>

<script>
export default {
  name: 'FloatingButton',

  methods: {
    openModal () {
      this.$emit('openModal')
    }
  }
}
</script>
